import { type ComponentType } from 'react';

import { DOIExperimentReportESRF } from './report/DOIExperimentReportESRF';
import { type DOI } from './utils/doi';
import { type Server } from './utils/fetching';

interface Config {
  SITE_PUBLISHER_NAME: string;
  LANDING_PAGE_LINK: string;
  DATA_ACCESS_LINK_INVESTIGATION: string;
  DATA_ACCESS_LINK_DOI: string;
  DOWNLOAD_REPORT_LINK: string;
  PUBLISHER_URL: string;
  USER_PORTAL_URL: string;
  // value for each key of type Server is a string
  SERVERS: Record<Server, string>;
  EXPERIMENT_REPORT:
    | {
        enabled: false;
      }
    | {
        enabled: true;
        component: ComponentType<{ doi: DOI }>;
      };
}

export const CONFIG: Config = {
  SITE_PUBLISHER_NAME: 'European Synchrotron Radiation Facility',
  LANDING_PAGE_LINK: 'https://doi.org/',
  DATA_ACCESS_LINK_INVESTIGATION:
    'https://data.esrf.fr/investigation/:id/datasets',
  DATA_ACCESS_LINK_DOI: 'https://data.esrf.fr/doi/:id/datasets',
  DOWNLOAD_REPORT_LINK:
    'https://nextup.esrf.fr/proposals/api/v1/proposals/{proposal}/experiment-sessions/files/',
  PUBLISHER_URL: 'https://www.esrf.fr/',
  USER_PORTAL_URL: 'https://smis.esrf.fr',
  SERVERS: {
    DATACITE: 'https://api.datacite.org/',
    CITATION: 'https://citation.doi.org/',
    OPENALEX: 'https://api.openalex.org/',
  },
  EXPERIMENT_REPORT: {
    enabled: true,
    component: DOIExperimentReportESRF,
  },
};
